export const SERVICES = [
  {
    slug: "estate-vineyard-management",
    title: "Estate Vineyard Management",
    summary: "Year-round, full-service farming of your vineyard, from pruning through harvest, with a dedicated manager on your ranch every week.",
    intro: "Full-service, year-round farming of your estate by a dedicated vineyard manager and crew. We take responsibility for the entire season, so ownership stays enjoyable and the fruit keeps getting better.",
    included: [
      "Weekly vineyard walks and manager reporting",
      "Pruning, canopy, and crop management",
      "Pest, disease, and irrigation programs",
      "Harvest planning and execution",
      "Annual budget with cost tracking in VineOps",
    ],
  },
  {
    slug: "vineyard-development-replanting",
    title: "Vineyard Development & Replanting",
    summary: "Site preparation, layout, rootstock and clone selection, and establishment farming through the first commercial crop.",
    intro: "From bare ground or tired vines to a producing vineyard. We plan and build vineyards meant to farm well for decades, not just establish quickly.",
    included: [
      "Site evaluation: soils, water, aspect, and climate",
      "Block layout, row orientation, and vine spacing",
      "Rootstock and clone selection for your site and goals",
      "Irrigation and infrastructure installation oversight",
      "Establishment farming through the first commercial crop",
    ],
  },
  {
    slug: "harvest-labor-management",
    title: "Harvest & Labor Management",
    summary: "Crew scheduling, harvest logistics, and quality control at picking, the days when details matter most.",
    intro: "The season is won or lost in a few weeks. We staff, schedule, and supervise the work, and we are in the field for every pick.",
    included: [
      "Crew scheduling and on-site supervision",
      "Maturity sampling and pick timing with your winemaker",
      "Night-harvest logistics and lighting",
      "Quality control at the bin",
      "Labor compliance and safety documentation",
    ],
  },
  {
    slug: "pest-disease-irrigation",
    title: "Pest, Disease & Irrigation Programs",
    summary: "Block-level scouting, treatment thresholds, and water strategy tuned to each site and each season.",
    intro: "Protection decisions made block by block, from field observation rather than habit, with water managed as carefully as the canopy.",
    included: [
      "Season-long, block-level scouting",
      "Treatment thresholds and targeted spray programs",
      "Powdery mildew, botrytis, and pest strategies",
      "Irrigation scheduling by block, soil, and weather",
      "Every application logged same-day in VineOps",
    ],
  },
  {
    slug: "budgeting-vineyard-reporting",
    title: "Budgeting & Vineyard Reporting",
    summary: "Annual farming plans, cost tracking, and complete operational reporting through VineOps.",
    intro: "You should never wonder what your vineyard costs or what happened on it. Every engagement runs on an annual plan you approve, tracked openly all season.",
    included: [
      "Annual farming plan and per-acre budget",
      "Cost tracking by block and by task",
      "Spray, labor, and activity records",
      "Yield estimates and harvest reporting",
      "Owner-ready reporting through VineOps",
    ],
  },
  {
    slug: "acquisition-due-diligence",
    title: "Acquisition & Due Diligence",
    summary: "Vineyard assessment for buyers evaluating Napa and Sonoma properties: vines, soils, water, and true farming costs.",
    intro: "Buying a vineyard property is an agricultural decision as much as a real estate one. We evaluate what you are actually buying before you close.",
    included: [
      "Vine age, health, and variety assessment",
      "Soils, water rights, and supply review",
      "Equipment and infrastructure condition",
      "True per-acre farming cost projections",
      "Replant and redevelopment estimates",
    ],
  },
  {
    slug: "safety-training-record-keeping",
    title: "Safety Training & Record Keeping",
    summary: "Tailgate meetings, heat-illness prevention, equipment and pesticide-safety training. Every session documented, every crew member on record, audit-ready at any time.",
    intro: "A documented safety program protects your crew and your ranch. Training happens on schedule, and the records are always ready for inspection.",
    included: [
      "Weekly bilingual tailgate meetings",
      "Heat illness prevention program",
      "Pesticide and handler safety training",
      "Equipment and tractor operator training",
      "Audit-ready training records in VineOps",
    ],
  },
  {
    slug: "wine-brand-support",
    title: "Wine Brand Support",
    summary: "Trusted partnerships with winemakers, branding professionals, and marketing experts, guiding your brand from fruit to market.",
    intro: "Beyond the vineyard, we help emerging and established wine brands move forward through trusted partnerships with experienced winemakers, branding professionals and marketing experts throughout Napa and Sonoma. From developing a new label to strengthening an existing brand, we can help connect the right people and guide the process from fruit to market.",
    included: [
      "Winemaker matching for your fruit and your style",
      "Label, identity, and packaging design partners",
      "Marketing and route-to-market guidance",
      "Introductions across our Napa and Sonoma network",
      "Support from first vintage to market launch",
    ],
  },
];
